function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { z } from 'zod';
import { filterByType } from "../../../data";
import { useRoadRunnerWorkflowStepDetailsAggregatedData } from "./aggregatedData";
export var WorkflowStepLogsSchema = z.object({
  id: z.string(),
  type: z.literal('evaluation_task_log'),
  attributes: z.object({
    type: z.string(),
    createdAt: z.string(),
    userLegacyId: z.number()["int"](),
    userEmail: z.string(),
    additionalData: z.record(z.string(), z.unknown())
  })
});
export function useWorkflowStepDetails(taskId) {
  var _useRoadRunnerWorkflo = useRoadRunnerWorkflowStepDetailsAggregatedData({
      select: function select(data) {
        var steps = filterByType(data.included, 'evaluation_task');
        return steps.find(function (step) {
          return step.id === taskId;
        });
      }
    }),
    data = _useRoadRunnerWorkflo.data,
    isFetching = _useRoadRunnerWorkflo.isFetching;
  if (!data) {
    throw new Error('Could not find step');
  }
  return {
    step: _objectSpread({
      id: data.id
    }, data.attributes),
    isFetchingStep: isFetching
  };
}
export function useWorkflowStepLogs() {
  var _data$meta$logsTotalC;
  var _useRoadRunnerWorkflo2 = useRoadRunnerWorkflowStepDetailsAggregatedData({
      select: function select(data) {
        return {
          stepLogs: filterByType(data.included, 'evaluation_task_log'),
          meta: data.meta
        };
      }
    }),
    data = _useRoadRunnerWorkflo2.data,
    isFetching = _useRoadRunnerWorkflo2.isFetching;
  var stepLogs = (data === null || data === void 0 ? void 0 : data.stepLogs.map(function (log) {
    return _objectSpread({
      id: log.id
    }, log.attributes);
  })) || [];
  return {
    stepLogs: stepLogs,
    isFetchingStepLogs: isFetching,
    totalCount: (_data$meta$logsTotalC = data === null || data === void 0 ? void 0 : data.meta.logsTotalCount) !== null && _data$meta$logsTotalC !== void 0 ? _data$meta$logsTotalC : 0
  };
}